
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import HeroSection from './components/HeroSection';
import ProductCategories from './components/ProductCategories';
import WhyChooseUs from './components/WhyChooseUs';
import CallToAction from './components/CallToAction';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ProductCategories />
        <WhyChooseUs />
        <CallToAction />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
